function _extends() {
  _extends = Object.assign || function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import MaterialBox from "../../../../../__snowpack__/pkg/@mui/material/Box.js";
import MaterialTable from "../../../../../__snowpack__/pkg/@mui/material/Table.js";
import MaterialTableContainer from "../../../../../__snowpack__/pkg/@mui/material/TableContainer.js";
import React from "react";
import TableSelectOptions from "../select-options/select-options.component.js";
import TableBody from "../table-body/table-body.component.js";
import TableHead from "../table-head/table-head.component.js";
import TablePagination from "../table-pagination/table-pagination.component.js";
import {TableContainer} from "./table.styles.js";
function Table({
  data,
  headers,
  limit = 10,
  type,
  onLimitChange,
  onOrderingChange,
  onPaginationChange,
  onRowSelect,
  onRowSelectAll,
  ordering,
  pagination,
  rowSelectOptions,
  selectable,
  fixSelect,
  selectedRows = [],
  total = data.length,
  tableLimits,
  ...rest
}) {
  return /* @__PURE__ */ React.createElement(MaterialBox, null, /* @__PURE__ */ React.createElement(TableSelectOptions, {
    hidden: selectedRows.length === 0,
    rowSelectOptions,
    selectedRows,
    type
  }), /* @__PURE__ */ React.createElement(TableContainer, null, /* @__PURE__ */ React.createElement(MaterialTableContainer, null, /* @__PURE__ */ React.createElement(MaterialTable, _extends({
    stickyHeader: true
  }, rest), /* @__PURE__ */ React.createElement(TableHead, {
    dataLength: data.length,
    headers,
    limit,
    onOrderingChange,
    onRowSelectAll,
    ordering,
    selectable,
    fixSelect,
    selectedRows
  }), /* @__PURE__ */ React.createElement(TableBody, {
    data,
    headers,
    onRowSelect,
    selectable,
    fixSelect,
    selectedRows
  }))), /* @__PURE__ */ React.createElement(TablePagination, {
    limit,
    tableLimits,
    onLimitChange,
    onPaginationChange,
    pagination,
    total
  })));
}
export default /* @__PURE__ */ React.memo(Table);
